import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import LoginReducer from '../components/Login/login-store/login-reducers';
import rootReducer from './root-reducers';

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
